import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ReflexContainer, ReflexElement, ReflexSplitter } from "react-reflex";
import { useSetRecoilState } from "recoil";

import layoutConf from "../../config/layoutConf";
import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";
import PopProductShipLotView from "./PopProductShipLotView";

import notificationState from "../../states/notificationState";
import PopCrudScreenActionItemLayout from "../screenTypes/layout/PopCrudScreenActionItemLayout";
import AccessControl from "../functional/AccessControl";
import getSchema from "../../lib/api/getSchema";

import PopProductShipOfOrderBuyerLotTemp from "./PopProductShipOfOrderBuyerLotTemp";
import PopProductShipOfOrderBuyerShipButton from "../input/PopProductShipOfOrderBuyerShipButton";
import { debounce } from 'lodash';

function PopProductShipOfOrderBuyer(props) {
    const { t } = useTranslation();

    const [height, setHeight] = useState(0);

    const [materialGird, setMaterialGrid] = useState();
    const [materialApi, setMaterialApi] = useState();
    const [materialSelect, setMaterialSelect] = useState({});
    const [mstGridEmpty, setMstGridEmpty] = useState();
    const [schema, setSchema] = useState();

    const setNotification = useSetRecoilState(notificationState);

    const handleResize = () => {
        setHeight(document.documentElement.offsetHeight - 96);
    };

    useEffect(() => {
        window.addEventListener("resize", handleResize);
        handleResize();
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
        let mounted = true;
        async function schemaSetting() {
            let schema = await getSchema("MomSysVwPopShipOfOrderBuyer");
            if (mounted) {
                setSchema(schema);
            }
        }

        schemaSetting();

        return (() => {
            mounted = false;
        });
    }, []);

    useEffect(() => {
        (async () => {
            if (materialGird) {
                materialGird.selectionChanged.addHandler(debounce((grid, event) => {
                    if (grid.selectedItems && grid.selectedItems[0]) {
                        setMaterialSelect(grid.selectedItems[0]);
                        setMstGridEmpty(false);
                    } else {
                        setMaterialSelect([]);
                        setMstGridEmpty(true);
                    };
                }, 10)
                );

                materialGird.itemsSourceChanged.addHandler(debounce((grid, event) => {
                    if (grid.selectedItems && grid.selectedItems[0]) {
                        setMaterialSelect(grid.selectedItems[0]);
                        setMstGridEmpty(false);
                    } else {
                        setMaterialSelect([]);
                        setMstGridEmpty(true);
                    };
                }, 10)
                );
            }
        })();
    }, [materialGird]);

    const onApiInitialized = (api) => {
        setMaterialApi(api);
    };

    const onInitialized = (grid) => {
        setMaterialGrid(grid);
    };

    const notifySuccess = (msg) => {
        setNotification({
            severity: "success",
            msg: msg,
            open: true,
        });
    };

    const onSuccess = (msg) => {
        notifySuccess(msg);
    };

    const notifyFailure = (msg) => {
        setNotification({
            severity: "error",
            msg: msg,
            open: true,
        });
    };

    const onFailure = (reason) => {
        notifyFailure(reason.response ? reason.response.data : reason);
    };

    const modifyUrlCallback = (url) => {
        return '/api/MomSysShipOfOrderBuyerLotTemp/popProductShipOk'
    }

    return (
        <div style={{ height: height }}>
            <ReflexContainer orientation="horizontal">
                <ReflexElement flex={0.6} data-cy="Master">
                    <BasicCrudScreenType
                        id="MomSysVwPopShipOfOrderBuyer"
                        table="MomSysVwPopShipOfOrderBuyer"
                        view="MomSysVwPopShipOfOrderBuyer"
                        headerTitle={t("term.materialAbailableShip")}
                        onApiInitialized={onApiInitialized}
                        onInitialized={onInitialized}
                        noCreate
                        noEdit
                        noDelete
                        noExcel
                        onAppendButtonInFrontOfSearch={() => (
                            <>
                                <PopCrudScreenActionItemLayout>
                                    <AccessControl accessTarget={schema && schema.name} accessMethod="POST">
                                        <PopProductShipOfOrderBuyerShipButton
                                            id="PopProductShipCreate"
                                            schema={schema}
                                            api={materialApi}
                                            materialSelect={materialSelect}
                                            onSuccess={onSuccess}
                                            onFailure={onFailure}
                                            createButtonName={"ship"}
                                            disabled={mstGridEmpty}
                                            modifyUrlCallback={modifyUrlCallback}
                                        />
                                    </AccessControl>
                                </PopCrudScreenActionItemLayout>
                            </>
                        )}
                    />
                </ReflexElement>

                <ReflexSplitter style={{ height: layoutConf.reflex.splitterHeight }} />

                <ReflexElement>
                    <ReflexContainer orientation="vertical">
                        <ReflexElement flex={0.5} data-cy="DetailMaterial">
                            <PopProductShipLotView shipmentSelect={materialSelect} />
                        </ReflexElement>

                        <ReflexSplitter style={{ width: layoutConf.reflex.splitterWidth }} />

                        <ReflexElement flex={0.5} data-cy="DetailLot">
                            <PopProductShipOfOrderBuyerLotTemp
                                materialSelect={materialSelect}
                                mstGridEmpty={mstGridEmpty}
                            />
                        </ReflexElement>
                    </ReflexContainer>
                </ReflexElement>
            </ReflexContainer>
        </div>
    );
}

export default PopProductShipOfOrderBuyer;
